import { z } from "zod";
/**
 * THE REGION GATE (Andre's rulings of 2026-10-27 and answers of 2026-10-28).
 * Fleuri Consulting Group, in Nevada, has no establishment in the EU or the UK,
 * and for now learners in the EU, the EEA and the UK are not offered the
 * service: at every door that writes rows or calls a model the api looks the
 * request's address up in a country table on its own server
 * (apps/api/src/geo/) and, for an excluded country, refuses with 451
 * Unavailable For Legal Reasons before anything is written.
 *
 * The refusal is one problem document. It names no country and no address: the
 * web needs only to know that this is the gate's refusal, and shows its one
 * screen (apps/web/src/ui/region-not-offered.tsx).
 */
export const REGION_NOT_OFFERED_STATUS = 451;
/**
 * The web's page for the same refusal, where a browser is sent when it cannot
 * read a problem document: Google's callback, a navigation, refused as it would
 * make an account (apps/api/src/routes/account.ts). A contract between the two.
 */
export const REGION_NOT_OFFERED_PAGE_HASH = "#/not-offered";
export const REGION_NOT_OFFERED_CODE = "REGION_NOT_OFFERED";
export const RegionNotOfferedProblemSchema = z.strictObject({
    type: z.string().min(1),
    title: z.string().min(1),
    status: z.literal(REGION_NOT_OFFERED_STATUS),
    code: z.literal(REGION_NOT_OFFERED_CODE),
    detail: z.string().min(1).optional(),
});
/** Whether a refusal the client read is the gate's: its status and its code together. */
export function isRegionNotOffered(problem) {
    return problem.status === REGION_NOT_OFFERED_STATUS && problem.code === REGION_NOT_OFFERED_CODE;
}
//# sourceMappingURL=region.js.map